import styled from 'styled-components'
import Button from '~/components/Buttons/Button'
import { HeightClass } from '~/utils/enum/classes'
import HierarchyCard from '../HierarchyCard'
import AreaLine from '~/components/AreaLine'

export const Container = styled(HierarchyCard)`
  & > :first-child {
    border-radius: 7px;
    padding: 0;
  }
`

export const StyledAreaLine = styled(AreaLine)`
  border-radius: 7px 7px 0 0;
`

export const HeaderRightArea = styled.div`
  display: flex;
  align-items: center;
  justify-content: right;
  gap: 8px;
`

export const CardContent = styled.div<{ heightClass: HeightClass }>`
  padding: ${({ theme, heightClass }) => theme.card[heightClass]?.padding}px;

  @media (max-width: 768px) {
    padding: 8px;
  }
`

export const ToggleButton = styled(Button)<{ arrowIconSize: HeightClass }>`
  padding: 0;
  background-color: transparent;

  && {
    border: none;
  }

  ${({ theme, arrowIconSize }) => `
    width: ${theme.icon.sizes[arrowIconSize]}px;
    height: ${theme.icon.sizes[arrowIconSize]}px;
  `};
`
